//* 按需导入插件
import type { ExtractPropTypes, PropType } from "vue";

export interface DiagramsOption {
    //* 数据Key
    "key": string;
    //* 表头名称
    "name": string;
    //* 插槽名称，未设置默认为key
    "slot"?: string;
    //* 列固定
    "fixed"?: boolean;
    //* 对齐方式
    "align"?: "left" | "center" | "singularity";
    //* 尺寸控制配置
    "width"?: number;
    //* 单元格合并规则
    "merge"?: (datas: any[], data: any, index: number) => { colspan?: number; rowspan?: number };
    //* 控制器
    "control"?: "sort" | "advanced";
    //* 反向排序
    "reverse"?: boolean;
    //* 备注内容
    "explain"?: string;
    //* 备注内容宽度
    "explain-width"?: number;
    //* 嵌套表头
    "children"?: DiagramsOption[];
    //* 内置类名
    "className"?: string;
    //* 检索候选项（仅control='advanced'生效）
    "selectors"?: { src?: string; name: string; value: string | number }[];
}

export interface DiagramsHeadOption extends DiagramsOption {
    rowspan: number;
    colspan: number;
}

export const DiagramsPropsOption = {
    //* 表格数据源
    data: { type: Array as PropType<any[]>, required: true },
    //* 数据空提示语
    empty: { type: String },
    //* 表格最小宽度宽度
    width: { type: Number },
    //* 表格配置项
    option: { type: Array as PropType<DiagramsOption[]>, required: true },
    //* 表头检索器
    searchHeader: { type: Boolean, default: false },
    //* 外置class
    externalTrAttrs: { type: Function as PropType<(datas: any[], data: any, index: number) => { [name: string]: string }> },
} as const;

export type DiagramsProps = ExtractPropTypes<typeof DiagramsPropsOption>;
//* 表格响应事件
export const DiagramsEmits = {
    advanced: (_result: {
        sort?: { key: string; value: string };
        search?: { [name: string]: string };
        checkboxs?: { key: string; value: any[] }[];
    }) => true, //* 高级检索
};
